<app-name-tag (close)="remove.emit()">{{ currentLabel() }}</app-name-tag>
